import { createSelector } from 'reselect'

const selectChatDomain = (state) => state.get('chat')

export const selectChatMessages = createSelector(
  selectChatDomain,
  (chatState) => chatState.get('messages')
)

export const selectConversationId = createSelector(
  selectChatDomain,
  (chatState) => chatState.get('conversationId')
)

export const selectConversations = createSelector(
  selectChatDomain,
  (chatState) => chatState.get('conversations')
)

export const selectConversationsLoading = createSelector(
  selectChatDomain,
  (chatState) => chatState.get('conversationsLoading')
)

export const selectDeletingConversationId = createSelector(
  selectChatDomain,
  (chatState) => chatState.get('deletingConversationId')
)

export const selectChatLoading = createSelector(
  selectChatDomain,
  (chatState) => chatState.get('isLoading')
)

export const selectChatError = createSelector(
  selectChatDomain,
  (chatState) => chatState.get('error')
)

export const selectChatWindowOpen = createSelector(
  selectChatDomain,
  (chatState) => chatState.get('isOpen')
)

export const selectChatStatus = createSelector(
  selectChatDomain,
  (chatState) => chatState.get('statusMessage')
)

export const selectChatScopeCode = createSelector(
  selectChatDomain,
  (chatState) => chatState.get('scopeCode')
)

export const selectChatFullscreen = createSelector(
  selectChatDomain,
  (chatState) => chatState.get('isFullscreen', false)
)
